module.exports = __webpack_public_path__ + "img/banner1.432e13f.png";